import React from "react";
import { SettingR } from "../route";
import { Redirect } from "react-router-dom";
import { useAuthContextV2 } from "../../../../auth-state";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import { SettingsTemplate } from "../../../template/settings/default-template";
import { Spinner } from "@graffer-inc/console-design-kit";
import {
  OrgSessionSettingService,
  OrgSessionSettingServiceProps,
} from "../../../../application/service/settings/org-session-setting/org-session-setting-service";
import { OrgSessionSettingForm } from "../../../organisms/settings/org-session-setting/setting-form";

export const OrgSessionSettingPage: React.FC<OrgSessionSettingServiceProps> = ({
  isLoading,
  availableIdleSessionTimeouts,
  currentIdleSessionTimeout,
  fetchOrgIdleSessionTimeoutSetting,
  updateOrgIdleSessionTimeoutSetting,
}) => {
  const { auth } = useAuthContextV2();

  React.useEffect(() => {
    if (auth.data?.orgId) {
      fetchOrgIdleSessionTimeoutSetting(auth.data.orgId);
    }
  }, [auth, fetchOrgIdleSessionTimeoutSetting]);

  if (
    !auth.data ||
    !auth.hasPermissions("tenant_management.org_session_settings.read")
  ) {
    return <Redirect to={SettingR.MyAccount.link({})} />;
  }

  if (isLoading) {
    <Spinner loading />;
  }

  return (
    <>
      <SettingsTemplate
        breadcrumbs={[
          {
            to: SettingR.OrgSessionSetting.link({}),
            title: "セッション有効期間設定",
          },
        ]}
      >
        <div className="columns">
          <div className="column is-8">
            <h1 className="title">
              <i className="fa fa-clock" /> セッション有効期間設定
            </h1>
          </div>
        </div>
        <hr />
        <div className="columns">
          <div className="column is-6">
            <OrgSessionSettingForm
              orgID={auth.data.orgId}
              availableIdleSessionTimeouts={availableIdleSessionTimeouts}
              currentIdleSessionTimeout={currentIdleSessionTimeout}
              updateOrgIdleSessionTimeoutSetting={
                updateOrgIdleSessionTimeoutSetting
              }
            />
          </div>
        </div>
      </SettingsTemplate>
    </>
  );
};

export const OrgSessionSettingContainer = connectPageService(
  OrgSessionSettingPage,
  () => new OrgSessionSettingService(),
);
